import React, { ReactElement } from 'react';
import { sessionApi } from '../../../../../../../../redux/views/session-view/session/api/api';
import { determineIsApexDemo, getSessionInformationFromSession } from './utils';
import { SessionInformation } from '.';

export function ConnectedDCloudSessionInformation({
  sessionUid,
  versionUid,
}: FetchSessionArgs): ReactElement {
  const { sessionInformation, isError, isLoading, isFetching, isApexDemo } =
    sessionApi.endpoints.getSession.useQueryState(
      { sessionUid, versionUid },
      {
        selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
          isApexDemo: determineIsApexDemo(data),
          isError,
          isFetching,
          isLoading,
          sessionInformation: getSessionInformationFromSession(data),
        }),
      },
    );

  return (
    <SessionInformation
      sessionInformation={sessionInformation}
      isLoading={isLoading || isFetching}
      isError={isError}
      isApexDemo={isApexDemo}
    />
  );
}
